var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import { Header } from '@s7/header';
import { useHeaderProfile } from '../api/useHeaderProfile';
import { useBonusMilesBalance } from '../model/useBonusMilesBalance';
export var HeaderProfileAuthorized = forwardRef(function (props, ref) {
    var lang = props.lang;
    var profile = useHeaderProfile(lang !== null && lang !== void 0 ? lang : 'ru')[0];
    var _a = useBonusMilesBalance(), miles = _a[0], milesState = _a[1];
    return (React.createElement(Header.Profile, __assign({ ref: ref }, props, { miles: miles, milesLoading: milesState.loading, profile: profile })));
});
